// @flow

// Exports
export default function asArray (value: mixed): Object {
  if (!Array.isArray(value)) {
    if (typeof value === 'object') {
      return Object.keys(value).map(function (key: string): any {
        return value[key]
      })
    } else {
      return []
    }
  }

  return value
}
